import React, { useEffect, useRef, useState } from 'react';
import { Image, ImageBackground, ImageSourcePropType, LayoutRectangle, PixelRatio, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { useDimensions } from 'react-native-web-hooks';
import useFontSize from '../../shell/hooks/useFontSize';
import ImageClass from '../../shell/Image';
import { isMobile } from '../../shell/utils/platformCheck';
import { Insta as InstaClass } from './InstaClass';
import { InstaNavBar } from './InstaNavBar';
import { InstaProfileINT } from './interfaces';


interface InstaWelcomeScreenProps {
    instaProfiles: InstaProfileINT[];
    onProfileClick: (profile: InstaProfileINT) => void,
    instaName: string,
}
// interface InstaProfile {
//     image: number,
//     name: string;

// }

export const InstaWelcomeScreen: React.FC<InstaWelcomeScreenProps> = ({ instaProfiles, onProfileClick, instaName }) => {
    const logo = require("@lss/common/game/assets/images/Instagram/Phone/SelectModel/BigLogo.webp")?.default || require("@lss/common/game/assets/images/Instagram/Phone/SelectModel/BigLogo.webp");
    const pc = require("@lss/common/game/assets/images/Instagram/Phone/pc.webp")?.default || require("@lss/common/game/assets/images/Instagram/Phone/pc.webp");
    // const backgroundSize = useRef<LayoutRectangle>();
    // const backgroundSize = useState<LayoutRectangle>();
    const [backgroundSize, setBackgroundSize] = useState<LayoutRectangle>();

    const { width, height } = useDimensions().window;
    const styles = StyleSheet.create({
        container: {
            height: "100%",
            width: "100%",
            aspectRatio: 16 / 9,
            alignSelf: "center"
        },
        pc: {
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            top: 0,
            // alignItems:"center"
        },
        logo: {
            width: (backgroundSize?.width || 1) / 7,
            height: (backgroundSize?.width || 1) / 7,
            marginTop: "1%",
            marginBottom: "2%"
        },
        mainNavStyle: {
            position: "relative",
            width: isMobile() ? 1425 / PixelRatio.get() : "74.2%",
            top: isMobile() ? 153 / PixelRatio.get() : "14.14%",
            right: isMobile() ? 12 / PixelRatio.get() : "0.6%",
            alignSelf: "center",
            alignItems: "center"
        },
        welcomeText: {
            position: "absolute",
            left: "18%",
            top: "22%",
            color: "black",
            fontSize: useFontSize(2.2)
        },
        followingContainer: {
            position: "absolute",
            // left: "43%",
            alignItems: "center",
            width: "100%",
            top: "30%",
            display: "flex"
        },
        followingText: {
            fontSize: useFontSize(2),
            alignSelf: "center",
            color: "black"

        },
        profileContainer: {

        },
        profileImageContainer: {
            flexDirection: "row",

        },
        profileImage: {
            width: (backgroundSize?.width || 1) / 12,
            height: (backgroundSize?.width || 1) / 12,
        },

    });

    const onCloseClick = () => {
        InstaClass.close();

    };

    return (
        <View style={styles.container} >
            <ImageBackground onLoad={(size) => {
            }} onLayout={(size) => {
                setBackgroundSize(size.nativeEvent.layout);
            }} style={styles.pc} source={pc} resizeMode={'cover'}>
                <InstaNavBar onCloseClick={onCloseClick} style={styles.mainNavStyle}></InstaNavBar>
                <Text style={styles.welcomeText}>Welcome Back, {instaName}</Text>
                <View style={styles.followingContainer}>
                    <Image resizeMode={"cover"} source={logo} style={styles.logo} />
                    <Text style={styles.followingText}>Following</Text>
                    <View style={styles.profileImageContainer}>

                        {
                            instaProfiles.map((profile: InstaProfileINT) => (

                                <TouchableOpacity onPress={() => onProfileClick(profile)} key={profile.key} style={styles.profileContainer}>
                                    <Image resizeMode={"cover"} source={(ImageClass._globalImages.get(profile.instaProfileImage.key)?.url || profile.instaProfileImage.url) as ImageSourcePropType} style={styles.profileImage} />


                                </TouchableOpacity>
                            ))
                        }
                    </View>

                </View>
            </ImageBackground>
        </View>
    );
};
